import { useEffect, useRef, useState } from 'react'
import { Loader } from 'lucide-react'
import './MobileMapWrapper.css'

function MobileMapWrapper({ children, onMapReady }) {
  const containerRef = useRef()
  const [isReady, setIsReady] = useState(false)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    // Function to calculate and set dimensions
    const updateDimensions = () => {
      const rect = container.getBoundingClientRect()
      const newDimensions = {
        width: rect.width || window.innerWidth,
        height: Math.max(rect.height, 300) || 300
      }
      
      setDimensions(newDimensions)
      
      // Mark as ready when we have valid dimensions
      if (newDimensions.width > 0 && newDimensions.height > 0) {
        setIsReady(true)
        if (onMapReady) {
          onMapReady(newDimensions)
        }
      }
    }

    // Initial calculation
    updateDimensions()

    // Handle resize events
    const resizeObserver = new ResizeObserver(() => {
      updateDimensions()
    })

    resizeObserver.observe(container)

    // Handle orientation changes on mobile
    const handleOrientationChange = () => {
      setTimeout(updateDimensions, 100)
    }

    window.addEventListener('orientationchange', handleOrientationChange)
    window.addEventListener('resize', updateDimensions)

    return () => {
      resizeObserver.disconnect()
      window.removeEventListener('orientationchange', handleOrientationChange)
      window.removeEventListener('resize', updateDimensions)
    }
  }, [onMapReady])

  return (
    <div 
      ref={containerRef} 
      className="mobile-map-wrapper"
      style={{
        width: '100%',
        height: '100%',
        minHeight: '300px',
        position: 'relative'
      }}
    >
      {!isReady && (
        <div className="mobile-map-loading">
          <Loader className="spinning" size={24} />
          <span>Loading map...</span>
        </div>
      )}
      
      <div 
        className={`mobile-map-content ${isReady ? 'ready' : 'loading'}`}
        style={{
          width: dimensions.width || '100%',
          height: dimensions.height || '100%',
          minHeight: '300px'
        }}
      >
        {isReady && children}
      </div>
    </div>
  )
}

export default MobileMapWrapper
